import { createContext } from "preact";
import { useContext } from "preact/hooks";

export interface ModalActions {
  open: (what: string, size?: string, swap?: number) => void;
  closeLast: () => void;
  close: (modalId: string) => void;
  refresh: () => void;
  closeLastRefresh: () => void;
  /** Number of currently open modals */
  depth: number;
  /** The "what" string of the currently‐open top modal, or "" */
  currentWhat: string;
}

export const ModalContext = createContext<ModalActions | null>(null);

export function useModal(): ModalActions {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useModal must be used within ModalStack");
  return ctx;
}
